module.exports = __webpack_public_path__ + "img/alternate-instagram-icon.d439363c.svg";